import styled from 'styled-components';

export const ActionButtonWrapper = styled.div`
  float: right;
  margin-top: 18px;
  padding-top: 10px;
  padding-bottom: 18px;
`;

export const StyledDurationSpan = styled.span`
  color: #6e7582;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  display: flex;
  align-items: center;
`;

export const StyledAsteriskSpan = styled.span`
  color: #de2f1b;
  padding-right: 3px;
`;

export const StyledErrorSpan = styled.span`
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #de2f1b;
`;
